import React from 'react';
import { Placeholder } from 'semantic-ui-react';
import { times } from 'lodash';

export function SemanticPlaceholder({ repeat = 4, withHeader = true, ...rest }) {
  return (
    <Placeholder {...rest}>
      {withHeader && (
        <Placeholder.Header image>
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder.Header>
      )}
      }
      {times(repeat, () => (
        <>
          <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
        </>
      ))}
    </Placeholder>
  );
}
